import ProfileFiles from './profile-files.vue'
export default ProfileFiles